import { Link } from "react-router-dom";
import { Disc3 } from "lucide-react";
import { resolveImg } from "@/lib/api";

const TYPE_LABEL = { album: "Album", ep: "EP", maxi: "Maxi" };

/** A project (album / EP / maxi) as a cover card that opens its page. */
export default function ReleaseCard({ release, badge }) {
  return (
    <Link to={`/release/${release.id}`} className="card-interactive overflow-hidden group block" data-testid={`release-${release.id}`}>
      <div className="relative aspect-square">
        <img src={resolveImg(release.cover)} alt={release.title} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />
        <span className="absolute top-3 left-3 chip bg-black/60 backdrop-blur text-white border border-white/10 inline-flex items-center gap-1">
          <Disc3 className="w-3 h-3" /> {TYPE_LABEL[release.release_type] || release.release_type}
        </span>
        {badge && <span className="absolute top-3 right-3 chip bg-emerald-500/90 text-black font-black">{badge}</span>}
        {release.published === false && <span className="absolute top-3 right-3 chip bg-amber-400 text-black font-black">Brouillon</span>}
      </div>
      <div className="p-4">
        <p className="font-semibold text-white truncate">{release.title}</p>
        <p className="text-xs text-zinc-400 truncate">{release.artist_name} · {release.tracks_count} titre{release.tracks_count > 1 ? "s" : ""}</p>
      </div>
    </Link>
  );
}
